module.exports = __webpack_public_path__ + "img/s02_p01-mobile.2e777845.png";